/**
 * FT13-U20: inter-company asset transfers (FSD 2.2.4.3 Transfer "between
 * locations, cost centres or companies, generating any inter-company entries
 * required"; FIN-FR-038).
 *
 * The INT packet spreads `ASSETS_IC_TRANSFER_ROUTES` and adds the nav item
 * `assets-ic-transfer`. The route's permission is the list it reads,
 * `GET /asset-disposals` (assets.asset.read): a transfer is the sending
 * entity's `ic_transfer` disposal. Starting one is gated on
 * `assets.transfer.intercompany` inside the screen.
 */

import type { RouteRecordRaw } from 'vue-router'

import { ASSETS_PERMISSIONS } from '@/modules/assets/permissions'

export const IC_TRANSFER_PATH = '/assets/ic-transfer'

export const ASSETS_IC_TRANSFER_ROUTES: RouteRecordRaw[] = [
  {
    path: IC_TRANSFER_PATH,
    name: 'assets-ic-transfer',
    component: () => import('@/modules/assets/ic-transfer/IcTransfersView.vue'),
    meta: {
      titleKey: 'assets.routeTitles.icTransfer',
      permission: ASSETS_PERMISSIONS.assetRead,
    },
  },
]
